<template>
  <div>
    <h1>Accueil</h1>
    <div v-for="group of moduleGroups" :key="group.IdFor">
      <h2>{{ group.NomGroupe }}</h2>
      <div class="modules">
        <div v-for="module of group.Modules" class="tile" :key="module.Id" @click="$router.push(module.Url)">
          <h3>{{module.Title}}</h3>
          <p>{{module.Desc}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { getModulesInGroups } from "@/utils/module"

  export default {
    name: 'Home',
    data() {
      return {
        moduleGroups: []
      }
    },
    mounted() {
      getModulesInGroups().then(res => {
        this.moduleGroups = res
      });
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1, h2 {
    font-weight: normal;
  }

  .modules {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 20px;
  }

  .tile {
      min-width: 250px;
      width: 20%;
      padding: 15px;
      border: 1px solid #ced4da;
      border-radius: .25rem;
      background-color: #FFFFFF;
      cursor: pointer;
      margin: 3px;
      min-height: 150px;
  }

  .tile > h3 {
      font-size: 22px;
      font-weight: 400;
  }

  .tile > p {
      font-weight: 100;
  }

</style>



// WEBPACK FOOTER //
// src/pages/Home.vue